/* ----------------------------------------
    App Configuration
---------------------------------------- */

const state = {
    0: {
        route: 'continue',
        buttonText: 'Compleet maken',
        buttonClass: 'btn-solid--orange',
    },
    1: {
        route: '/project/[projectId]/1/ingediend',
        buttonText: 'Ingediend',
        buttonClass: 'btn-ghost--gray',
    },
    2: {
        route: '/project/[projectId]/2/behandeling',
        buttonText: 'In behandeling',
        buttonClass: 'btn-solid--green',
    },
    3: {
        route: '/project/[projectId]/3/aanvullen',
        buttonText: 'Aanvullen',
        buttonClass: 'btn-solid--orange',
    },
    4: {
        route: '/project/[projectId]/4/afgewezen',
        buttonText: 'Afgewezen / goedgekeurd',
        buttonClass: 'btn-solid--orange',
    },
    5: {
        route: '/project/[projectId]/5/contract',
        buttonText: 'Contract tekenen',
        buttonClass: 'btn-solid--orange',
    },
    6: {
        route: '/project/[projectId]/6/wordt-betaald',
        buttonText: 'Wordt betaald',
        buttonClass: 'btn-solid--green',
    },
    7: {
        route: '/project/[projectId]/7/tussentijds-verslag',
        buttonText: 'Tussentijds verslag opleveren',
        buttonClass: 'btn-solid--orange',
    },
    8: {
        route: '/project/[projectId]/8/eindafrekening',
        buttonText: 'Eindafrekening opleveren',
        buttonClass: 'btn-solid--orange',
    },
    9: {
        route: '/project/[projectId]/9/eindafrekening-behandeling',
        buttonText: 'Eindafrekening in behandeling',
        buttonClass: 'btn-solid--green',
    },
    10: {
        route: '/project/[projectId]/10/terugbetalen',
        buttonText: 'Deel donatie terugbetalen',
        buttonClass: 'btn-solid--orange',
    },
    11: {
        route: '/project/[projectId]/11/afgerond',
        buttonText: 'Afgerond',
        buttonClass: 'btn-solid--green',
    },
};

/* ----------------------------------------
    Export Module
---------------------------------------- */

module.exports = {
    state
};
